import { Card, CarouselSection, Text } from '@/components';
import APP_CONFIG from '@/config/app';
import { CarouselScreenProps } from '@/interfaces';
import { SMALL_SCREEN_BOUNDARY } from '@/utils/strings';
import Image from 'next/image';
import { Component, PropsWithChildren } from 'react';
interface MinimumScreenSizeBoundaryProps extends PropsWithChildren {}
class MinimumScreenSizeBoundary extends Component<MinimumScreenSizeBoundaryProps> {
  state = { screenTooSmall: false };
  componentDidMount() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
  }
  checkScreenSize = () => {
    this.setState({
      screenTooSmall: window.innerWidth < APP_CONFIG.MINIMUM_SCREEN_WIDTH,
    });
  };
  render() {
    if (this.state.screenTooSmall) {
      const slides: CarouselScreenProps[] = [
        {
          body: (
            <div className="flex flex-col h-full justify-center items-center gap-md text-center">
              <div className="flex items-center justify-center pb-12">
                <Image
                  src={APP_CONFIG.SMALL_SCREEN_ILLUSTRATION_URL}
                  alt="Screen Too Small Illustration"
                  className="object-contain"
                  layout="responsive"
                  width={100}
                  height={100}
                />
              </div>
              <div
                className="flex flex-col items-center mx-auto"
                style={{ maxWidth: '30rem' }}
              >
                <div className="flex flex-col items-center justify-center gap-sm w-full">
                  <Text
                    size="h3"
                    color="accent"
                    className="font-sans w-full text-left"
                  >
                    {SMALL_SCREEN_BOUNDARY.TITLE}
                  </Text>
                  <Text
                    color="secondary"
                    className="font-sans w-full text-left"
                  >
                    {SMALL_SCREEN_BOUNDARY.DECRIPTION}
                  </Text>
                </div>
              </div>
            </div>
          ),
        },
      ];
      return (
        <div className="grid place-items-center w-screen h-screen p-md">
          <Card className="w-full h-full p-md gap-md flex flex-col overflow-y-auto overflow-x-hidden scrollbar-hide">
            <div className="flex justify-center items-center w-full h-full">
              <CarouselSection
                screens={slides}
                showNavigationControlsInHeader={false}
                autoNavigate={false}
                className="w-full p-md"
                isBackgroundTransparent={true}
                isBorderTransparent={true}
              />
            </div>
          </Card>
        </div>
      );
    }
    return this.props.children;
  }
}
export default MinimumScreenSizeBoundary;
